function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.8 16.4l-.2-.1v-.1s.8-4 1.4-6.1c-.3 0-.8.1-1.3.2-1.4.2-2.3.4-2.7.2l.1-.1c.2-.5.4-.9.5-1.4C1.7 6.2 3 2.6 4.6.2V.1h.1c.3-.1.6-.1.9-.1H9.3l-.2.2c-.6 1.3-1.5 2.9-2.3 4.4-.4.7-.8 1.4-1.1 2 .9 0 3.4-.3 4.8-.4h.4l-.5.6c-5.5 7.2-6.9 9-7.3 9.5-.2.1-.3.1-.3.1zm1.5-6.6H4.6l-.1.2c-.5 1.4-1.1 4.3-1.4 5.5.7-.9 2.4-3.1 6.8-8.9v-.1c-1 .2-4.1.4-4.5.4h-.3l.1-.2c.4-.7.8-1.4 1.3-2.2.8-1.4 1.6-2.8 2.2-4H4.8C3.3 2.9 2 6.3 1 9c-.2.4-.3.8-.5 1.2.5 0 1.5-.2 2.3-.3.7 0 1.2-.1 1.5-.1z",
  fill: "#af9c7e"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.3 9.8H4.6l-.1.2c-.5 1.4-1.1 4.1-1.3 5.3.6-.8 2.3-3 6.6-8.5v-.1c-1 .1-4.1.3-4.4.3h-.2l.1-.2c.3-.6.7-1.3 1.2-2.1C7.2 3.4 8 2 8.6.9H4.8C3.4 3.2 2.2 6.4 1.2 9.1c-.2.4-.3.8-.5 1.2.4 0 1.5-.1 2.2-.3.7-.1 1.2-.2 1.4-.2z",
  fill: "#f19c97"
});

var SvgLightning = function SvgLightning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 10.8 16.4",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLightning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightning.f1fd2f94.svg";
export { ForwardRef as ReactComponent };